import { createApp, type App } from 'vue';
import type { AuthUser } from '../core/state/auth-store';
import HeroScreen from './ui/HeroScreen.vue';
import { i18n } from './i18n';

/**
 * Engine bootstrap — Fimbulwake mounts its Vue app here (the `/play` slot).
 * The core owns auth/network/state (vanilla TS); the game UI is Vue.
 * Phaser/Pixi canvases will be wrapped in Vue components in P2.
 */
let app: App | null = null;
let currentTeardown: (() => void) | null = null;

export function mountGame(root: HTMLElement, user: AuthUser, onLogout: () => void): () => void {
  root.innerHTML = '';
  app = createApp(HeroScreen, { user, onLogout });
  app.use(i18n);
  app.mount(root);
  currentTeardown = () => {
    app?.unmount();
    app = null;
  };
  return currentTeardown;
}

export function unmountGame(): void {
  currentTeardown?.();
  currentTeardown = null;
}
